import { fromJS } from 'immutable'
import {
  SALE_PRODUCT_EDIT_REQUEST,
  SALE_PRODUCT_EDIT_SUCCESS,
  SALE_PRODUCT_EDIT_FAILURE,
  SALE_PRODUCT_EDIT_RESET,
} from '../../actions/sale-product/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SALE_PRODUCT_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case SALE_PRODUCT_EDIT_SUCCESS:
      return state
        .set('isFetching', false)
        .set('type', 'success')
        .set('status', 'Updated Successfully')
        .set('message', 'The data had successfully been updated')
        .set('updatedProduct', fromJS(action.payload.updatedProduct))
    case SALE_PRODUCT_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('type', 'error')
        .set('status', 'Error')
        .set('updatedProduct', fromJS(action.payload.message))
        .set('message', fromJS(action.payload.response.message))
    case SALE_PRODUCT_EDIT_RESET:
      return state
        .set('isFetching', false)
        .set('type', null)
        .set('status', null)
        .set('updatedProduct', null)
        .set('message', null)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sale-product/sale-product-update-reducer.js